<template>
  <section class="faq-section">
    <div class="container">
      <h2 class="faq-title">Отвечаем на часто задаваемые вопросы</h2>
      <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
        <div class="faq-question" @click="toggle(index)">
          <span>{{ faq.question }}</span>
          <button class="faq-toggle">
            {{ openedIndex === index ? "-" : "+" }}
          </button>
        </div>
        <div class="faq-answer" v-if="openedIndex === index">
          {{ faq.answer }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";

const faqs = [
  {
    question: "Что происходит после окончания Free лимита?",
    answer: "Начинается платный период.",
  },
  {
    question: "Могу ли я изменить тариф?",
    answer: "Да.",
  },
  {
    question: "Есть ли пробный период для Pro?",
    answer: "Да.",
  },
  {
    question:
      "Смогу ли я получать заявки в маркетплейсе, не оплачивая никакой тариф?",
    answer: "Да.",
  },
];

const openedIndex = ref(null);

function toggle(index) {
  openedIndex.value = openedIndex.value === index ? null : index;
}
</script>

<style scoped lang="scss">
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.faq-section {
  background: rgba(245, 247, 250, 1);
  padding: 64px 20px;
}
.faq-title {
  text-align: start;
  font-size: 45px;
  font-weight: 700;
  max-width: 500px;
  margin: 0 auto 72px auto;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 32px;
  }
}
.faq-item {
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(62, 62, 62, 0.3);
  padding: 8px 0;
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
}
.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
}
.faq-answer {
  margin-top: 10px;
  color: #555;
  font-size: 14px;
}
.faq-toggle {
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  background: rgba(0, 199, 130, 1);
  border-radius: 50%;
  border: none;
  color: #fff;
  font-size: 30px;
}
</style>
